// Source unique des clés react-query. Ne jamais écrire de queryKey en dur ailleurs :
// une clé fautée devient ici une erreur de compilation plutôt qu'un cache silencieusement périmé.
export const queryKeys = {
  me: ["me"] as const,
  accounts: ["accounts"] as const,
  rights: (idUserAPI: number) => ["rights", idUserAPI] as const,
  locatsReferential: ["locats-referential"] as const,
  marketsReferential: ["markets-referential"] as const,
  /** Recherche de sociétés, une entrée de cache par texte cherché. */
  companySearch: (search: string) => ["company-search", search] as const,
};
